// Sticky header init
export default function stickyHeaderInit(){
    function headerSticky() {
      if (document.querySelector('.order-page')) return false;
  
      var header = document.querySelector('.header__content'),
        state = {
          position: null
        },
        isOrderPage = document.documentElement.classList.contains('order-page-wrapper');
  
  
      var onScrollHandler = function (e) {
        var mobileNavIsActive = document.querySelector('.hamburger').classList.contains('is-active');
        if (window.innerWidth > 1215) {
          if (window.scrollY > 250) {
            header.classList.add('sticky');
          } else {
            header.classList.remove('sticky');
          }
        } else {
          if (window.scrollY > 50 && !isOrderPage && !mobileNavIsActive) {
            if (state.position > window.scrollY) {
              header.classList.remove('hidden');
              header.classList.add('visible');
            } else {
              header.classList.remove('visible');
              header.classList.add('hidden');
            }
  
            state.position = window.scrollY
          }
        }
      }
  
      window.addEventListener('scroll', onScrollHandler);
    }
  
    window.addEventListener('load', headerSticky);
  }